export type AuthErrorCode =
  | 'server_config'
  | 'no_code'
  | 'invalid_state'
  | 'token_exchange'
  | 'fejwt'
  | 'userinfo'
  | 'unauthorized'
  | 'session_expired'
  | 'not_authenticated'
  | 'refresh_failed'
  | 'method_not_allowed';

export class AuthError extends Error {
  readonly code: AuthErrorCode;
  readonly statusCode: number;
  readonly details?: unknown;

  constructor(code: AuthErrorCode, message?: string, options?: { statusCode?: number; details?: unknown }) {
    super(message ?? code);
    this.name = 'AuthError';
    this.code = code;
    this.statusCode = options?.statusCode ?? AuthError.defaultStatus(code);
    this.details = options?.details;
  }

  private static defaultStatus(code: AuthErrorCode): number {
    switch (code) {
      case 'not_authenticated':
      case 'session_expired':
      case 'unauthorized':
        return 401;
      case 'method_not_allowed':
        return 405;
      case 'server_config':
        return 500;
      case 'refresh_failed':
      case 'token_exchange':
      case 'fejwt':
      case 'userinfo':
        return 502;
      default:
        return 400;
    }
  }
}
